<div
  class="z-[999] fixed inset-0 bg-black/50 backdrop-blur-xs flex items-center justify-center"
  role="dialog"
  aria-modal="true"
>
  <!-- CARD -->
  <div
    class="bg-white rounded-2xl shadow-2xl ring-1 ring-black/5
           h-[530px] xl:h-[550px] 2xl:h-[570px] 3xl:h-[670px] max-h-[90vh] max-w-[90vw]
           flex flex-col overflow-hidden
           w-[860px] xl:w-[940px] 2xl:w-[910px] 3xl:w-[990px] 4xl:w-[1070px]"
  >
    <!-- HEADER -->
    <div class="flex-none flex items-start justify-between gap-4 px-6 pt-5 pb-3">
      <div class="min-w-0 flex flex-col gap-1">
        <h1 class="text-dimot-1 text-[0.84rem] xl:text-[1.03rem] 2xl:text-[1rem] text-start">
          Personalizzazione {{ titleCardInCustom }}
        </h1>
        <p class="text-[0.55rem] xl:text-[0.62rem] 2xl:text-[0.7rem] 3xl:text-[0.85rem] leading-relaxed text-gray-500 text-start">
          Personalizza la tua mappa e scegli se generare la singola slide o il report nazionale.
        </p>
      </div>

      <button
        type="button"
        (click)="onCloseModal(false)"
        aria-label="Chiudi"
        class="shrink-0 -mr-2 -mt-1 grid place-items-center rounded-full p-2 cursor-pointer
               focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-dimot-1/40
               transition-colors"
      >
        <svg
          class="w-4 h-4 xl:w-5 xl:h-5 2xl:w-6 2xl:h-6"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.1471 18.3525C19.2024 18.404 19.2467 18.4661 19.2775 18.5351C19.3082 18.6041 19.3248 18.6786 19.3261 18.7541C19.3274 18.8296 19.3135 18.9047 19.2852 18.9747C19.2569 19.0447 19.2148 19.1084 19.1614 19.1618C19.108 19.2152 19.0444 19.2573 18.9743 19.2856C18.9043 19.3139 18.8293 19.3278 18.7537 19.3265C18.6782 19.3251 18.6037 19.3086 18.5347 19.2778C18.4657 19.2471 18.4036 19.2028 18.3521 19.1475L11.9996 12.7959L5.64714 19.1475C5.54051 19.2469 5.39947 19.301 5.25375 19.2984C5.10802 19.2958 4.96898 19.2368 4.86592 19.1337C4.76286 19.0307 4.70383 18.8916 4.70126 18.7459C4.69869 18.6002 4.75278 18.4591 4.85214 18.3525L11.2037 12L4.85214 5.64751C4.75278 5.54088 4.69869 5.39984 4.70126 5.25411C4.70383 5.10839 4.76286 4.96935 4.86592 4.86629C4.96898 4.76323 5.10802 4.7042 5.25375 4.70163C5.39947 4.69905 5.54051 4.75315 5.64714 4.85251L11.9996 11.2041L18.3521 4.85251C18.4588 4.75315 18.5998 4.69905 18.7455 4.70163C18.8913 4.7042 19.0303 4.76323 19.1334 4.86629C19.2364 4.96935 19.2955 5.10839 19.298 5.25411C19.3006 5.39984 19.2465 5.54088 19.1471 5.64751L12.7956 12L19.1471 18.3525Z"
            fill="#141F58"
          />
        </svg>
      </button>
    </div>

    <!-- LOADING -->
    <div
      *ngIf="isLoading"
      class="flex-1 flex flex-col w-full justify-center items-center gap-3"
      role="status"
    >
      <svg
        aria-hidden="true"
        class="w-12 h-12 text-gray-200 animate-spin fill-[#141F58]"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="currentColor"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentFill"
        />
      </svg>
    </div>

    <!-- CONTENT -->
    <div *ngIf="!isLoading" class="flex-1 flex min-h-0 border-t border-gray-200">

      <!-- LEFT: VALUES -->
      <div class="flex-1 min-w-0 flex flex-col">

      <div class="flex-none flex border-b border-gray-200 bg-tableHead">

        <div class="flex-1 min-w-0 overflow-y-hidden [scrollbar-gutter:stable]">
          <table class="w-full h-full table-fixed">
            <colgroup>
              <col class="w-1/3" />
              <col class="w-1/3" />
              <col class="w-1/3" />
            </colgroup>
            <thead>
              <tr
                class="h-[40px] xl:h-[45px] 2xl:h-[50px]
                       text-[0.5rem] xl:text-[0.55rem] 2xl:text-[0.58rem] 3xl:text-[0.67rem]
                       font-semibold uppercase tracking-wider text-gray-500"
              >
                <th class="text-start pl-7">REGIONE</th>
                <th class="text-start pl-6 pr-3 leading-tight">APERTURA IN ECONOMIA</th>
                <th class="text-start pl-6 pr-3 leading-tight">APERTURA OSPEDALIERA</th>
              </tr>
            </thead>
          </table>
        </div>
      </div>

        <!-- TABLE -->
        <div class="relative flex-1 min-h-0 overflow-y-auto scrollbar2 [scrollbar-gutter:stable]">
          <table class="w-full table-fixed">
            <colgroup>
              <col class="w-1/3" />
              <col class="w-1/3" />
              <col class="w-1/3" />
            </colgroup>
            <tbody>
              <tr
                *ngFor="let region of mergedData; let i = index"
                class="h-10 xl:h-12 2xl:h-14 text-dimot-1 border-b border-gray-100
                       hover:bg-[#F7F9FC] transition-colors"
              >
                <!-- REGIONS -->
                <td class="text-start pl-7 text-[0.53rem] xl:text-[0.6rem] 2xl:text-[0.6rem] 3xl:text-[0.7rem] font-medium">
                  {{
                    region.regionName === 'Prov. Aut. di Trento' ? 'PA Trento' :
                    region.regionName === 'Prov. Aut. di Bolzano' ? 'PA Bolzano' :
                    region.regionName
                  }}
                </td>

                <!-- ECONOMIA -->
                <td>
                  <label
                    *ngIf="region.economiaAvailable"
                    class="flex justify-start pl-6 cursor-pointer"
                  >
                    <input
                      type="radio"
                      class="sr-only peer"
                      [name]="'region-' + i"
                      [checked]="region.selected === 'economia'"
                      (change)="selectValue(region, 'economia')"
                    />
                    <span
                      class="inline-flex items-center gap-1 2xl:gap-2 text-[0.53rem] xl:text-[0.6rem] 2xl:text-[0.6rem] 3xl:text-[0.7rem]"
                      [ngClass]="region.selected === 'economia' ? 'text-dimot-1 font-semibold' : 'text-gray-600'"
                    >
                      <span
                        class="shrink-0 w-[11px] h-[11px] 2xl:w-[14px] 2xl:h-[14px] rounded-full border-2 flex items-center justify-center"
                        [ngClass]="region.selected === 'economia' ? 'border-dimot-1' : 'border-gray-500'"
                      >
                        <span
                          class="w-[5px] h-[5px] 2xl:w-[6px] 2xl:h-[6px] rounded-full bg-dimot-1"
                          [ngClass]="region.selected === 'economia' ? 'opacity-100' : 'opacity-0'"
                        ></span>
                      </span>
                      <span class="text-left">{{ region.valueEconomia }}</span>
                    </span>
                  </label>

                  <div *ngIf="!region.economiaAvailable" class="flex justify-start pl-6">
                    <span class="text-[0.53rem] xl:text-[0.6rem] 2xl:text-[0.6rem] 3xl:text-[0.7rem] text-gray-400">
                      Non presente
                    </span>
                  </div>
                </td>

                <!-- MERCATO -->
                <td>
                  <label
                    class="flex justify-start pl-6"
                    [ngClass]="region.inEconomia ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'"
                  >
                    <input
                      type="radio"
                      class="sr-only peer"
                      [name]="'region-' + i"
                      [checked]="region.selected === 'openToMarket'"
                      [disabled]="region.inEconomia"
                      (change)="selectValue(region, 'openToMarket')"
                    />
                    <span
                      class="inline-flex items-center gap-1 2xl:gap-2 text-[0.53rem] xl:text-[0.6rem] 2xl:text-[0.6rem] 3xl:text-[0.7rem]"
                      [ngClass]="region.selected === 'openToMarket' ? 'text-dimot-1 font-semibold' : 'text-gray-600'"
                    >
                      <span
                        class="shrink-0 w-[11px] h-[11px] 2xl:w-[14px] 2xl:h-[14px] rounded-full border-2 flex items-center justify-center"
                        [ngClass]="region.selected === 'openToMarket' ? 'border-dimot-1' : 'border-gray-500'"
                      >
                        <span
                          class="w-[5px] h-[5px] 2xl:w-[6px] 2xl:h-[6px] rounded-full bg-dimot-1"
                          [ngClass]="region.selected === 'openToMarket' ? 'opacity-100' : 'opacity-0'"
                        ></span>
                      </span>
                      <span class="text-left">{{ region.valueOpenToMarket }}</span>
                    </span>
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

    <!-- ACTIONS -->
    <div
      class="flex-none flex items-center justify-center gap-4 px-4 pt-8 pb-5"
    >
      <button
        (click)="generateSingleSlide()"
        [disabled]="isLoading || isGeneratingSlide"
        type="button"
        class="w-[140px] h-[30px] 2xl:w-[170px] 2xl:h-[38px] justify-center rounded-lg border border-[#0A778A] bg-white text-[#0A778A]
               text-[0.5rem] 2xl:text-[0.6rem] font-medium inline-flex items-center gap-2 cursor-pointer
               hover:bg-[#0A778A]/10 active:scale-[0.98] transition
               disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:bg-white disabled:active:scale-100
               focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0A778A]/40"
      >
        <span>{{ isGeneratingSlide ? 'Generazione in corso...' : 'Genera Singola Slide' }}</span>
        <svg
          class="relative bottom-[1px] w-[13px] h-[13px] 2xl:w-[15px] 2xl:h-[15px] 3xl:w-[17px] 3xl:h-[17px]"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M13.875 9V13C13.875 13.0995 13.8355 13.1948 13.7652 13.2652C13.6948 13.3355 13.5995 13.375 13.5 13.375H2.5C2.40054 13.375 2.30516 13.3355 2.23483 13.2652C2.16451 13.1948 2.125 13.0995 2.125 13V9C2.125 8.90054 2.16451 8.80516 2.23483 8.73483C2.30516 8.66451 2.40054 8.625 2.5 8.625C2.59946 8.625 2.69484 8.66451 2.76517 8.73483C2.83549 8.80516 2.875 8.90054 2.875 9V12.625H13.125V9C13.125 8.90054 13.1645 8.80516 13.2348 8.73483C13.3052 8.66451 13.4005 8.625 13.5 8.625C13.5995 8.625 13.6948 8.66451 13.7652 8.73483C13.8355 8.80516 13.875 8.90054 13.875 9ZM7.735 9.265C7.80531 9.33523 7.90062 9.37467 8 9.37467C8.09938 9.37467 8.19469 9.33523 8.265 9.265L10.765 6.765C10.8312 6.69391 10.8673 6.59989 10.8656 6.50274C10.8639 6.40559 10.8245 6.3129 10.7558 6.24419C10.6871 6.17548 10.5944 6.13613 10.4973 6.13441C10.4001 6.1327 10.3061 6.16876 10.235 6.235L8.375 8.09437V2C8.375 1.90054 8.33549 1.80516 8.26517 1.73483C8.19484 1.66451 8.09946 1.625 8 1.625C7.90054 1.625 7.80516 1.66451 7.73484 1.73483C7.66451 1.80516 7.625 1.90054 7.625 2V8.09437L5.765 6.235C5.69391 6.16876 5.59989 6.1327 5.50274 6.13441C5.40559 6.13613 5.3129 6.17548 5.24419 6.24419C5.17548 6.3129 5.13613 6.40559 5.13441 6.50274C5.1327 6.59989 5.16876 6.69391 5.235 6.765L7.735 9.265Z"
            fill="currentColor"
          />
        </svg>
      </button>

      <button
        (click)="handleModalChange(true)"
        [disabled]="isLoading || isGeneratingSlide"
        type="button"
        class="w-[140px] h-[30px] 2xl:w-[170px] 2xl:h-[38px] justify-center rounded-lg bg-[#0A778A] text-white shadow-sm
               text-[0.5rem] 2xl:text-[0.6rem] font-medium inline-flex items-center gap-2 cursor-pointer
               hover:bg-[#0D9CB5] active:scale-[0.98] transition
               disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:bg-[#0A778A] disabled:active:scale-100
               focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0A778A]/40 focus-visible:ring-offset-2"
      >
        <span>Genera Report Nazionale</span>
        <svg
          class="relative bottom-[1px] w-[13px] h-[13px] 2xl:w-[15px] 2xl:h-[15px] 3xl:w-[17px] 3xl:h-[17px]"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M13.875 9V13C13.875 13.0995 13.8355 13.1948 13.7652 13.2652C13.6948 13.3355 13.5995 13.375 13.5 13.375H2.5C2.40054 13.375 2.30516 13.3355 2.23483 13.2652C2.16451 13.1948 2.125 13.0995 2.125 13V9C2.125 8.90054 2.16451 8.80516 2.23483 8.73483C2.30516 8.66451 2.40054 8.625 2.5 8.625C2.59946 8.625 2.69484 8.66451 2.76517 8.73483C2.83549 8.80516 2.875 8.90054 2.875 9V12.625H13.125V9C13.125 8.90054 13.1645 8.80516 13.2348 8.73483C13.3052 8.66451 13.4005 8.625 13.5 8.625C13.5995 8.625 13.6948 8.66451 13.7652 8.73483C13.8355 8.80516 13.9355 8.90054 13.875 9ZM7.735 9.265C7.80531 9.33523 7.90062 9.37467 8 9.37467C8.09938 9.37467 8.19469 9.33523 8.265 9.265L10.765 6.765C10.8312 6.69391 10.8673 6.59989 10.8656 6.50274C10.8639 6.40559 10.8245 6.3129 10.7558 6.24419C10.6871 6.17548 10.5944 6.13613 10.4973 6.13441C10.4001 6.1327 10.3061 6.16876 10.235 6.235L8.375 8.09437V2C8.375 1.90054 8.33549 1.80516 8.26517 1.73483C8.19484 1.66451 8.09946 1.625 8 1.625C7.90054 1.625 7.80516 1.66451 7.73484 1.73483C7.66451 1.80516 7.625 1.90054 7.625 2V8.09437L5.765 6.235C5.69391 6.16876 5.59989 6.1327 5.50274 6.13441C5.40559 6.13613 5.3129 6.17548 5.24419 6.24419C5.17548 6.3129 5.13613 6.40559 5.13441 6.50274C5.1327 6.59989 5.16876 6.69391 5.235 6.765L7.735 9.265Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>
      </div>

      <!-- RIGHT: MAP PREVIEW -->
      <div
        class="flex-none flex border-l border-gray-200 px-3 pt-3 pb-5
               w-[310px] xl:w-[340px] 2xl:w-[360px] 3xl:w-[400px] 4xl:w-[440px]"
      >
        <div class="flex-1 min-h-0 p-1.5">
          <ejs-maps
            #previewMap
            id="ht-merged-container"
            style="display: block"
            width="100%"
            height="100%"
            [layers]="layers"
          ></ejs-maps>
        </div>
      </div>
    </div>
  </div>
</div>

<app-generate-national-report
  *ngIf="isGenerateNationalPPTModuleOpen"
  (isModalOpen)="handleModalChange($event)"
  [medicineInfoData]="medicineInfoDataInCustom"
  [widgetsAvailable]="widgetsAvailableInCustom"
  [isCustomHeatmapOpenToMarket]="true"
  [customHeatmapDataInReport]="customHeatmapData"
></app-generate-national-report>

<!-- Off-screen map used only to export the PNG for "Genera Singola Slide" -->
<div *ngIf="isGeneratingSlide" class="fixed -left-[10000px] top-0 w-[600px] h-[468px]" aria-hidden="true">
  <ejs-maps
    #exportMap
    id="ht-merged-export-container"
    width="100%"
    height="100%"
    [layers]="layers"
    [allowImageExport]="true"
    (loaded)="onExportMapLoaded()"
  ></ejs-maps>
</div>